import { NgModule, enableProdMode, isDevMode } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
// Removed duplicate import of FilterPipe


import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  UtilitiesModule,

} from '@coreui/angular';
import { IconModule, IconSetService } from '@coreui/icons-angular';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { ToastrModule } from 'ngx-toastr';

import { NgScrollbarModule } from 'ngx-scrollbar';

import { provideUserIdleConfig } from 'angular-user-idle';

import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dailog.service';

import { MultiSelectModule } from 'primeng/multiselect';

import { environment } from 'src/environments/environment';

import { CKEditorModule } from 'ng2-ckeditor';

import { ExportAsModule } from 'ngx-export-as';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
} from './containers';

import { SharedCoreModule } from './shared/shared.module';
import * as roleReducer from './store/roles';
import { CoreModule } from './core/directives/core.module';
import { CustomHttpInterceptor } from './core/interceptors/http.interceptor';
import { AnnouncementComponent } from './pages/announcement/announcement.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { Page403Component } from './pages/page403/page403.component';
import { Page404Component } from './pages/page404/page404.component';
import { Page500Component } from './pages/page500/page500.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { DepositeFiatCommisionComponent } from './pages/deposite-fiat-comisions/deposite-fiat-commision/deposite-fiat-commision.component';
import { DepositeFiatDetailsComponent } from './pages/deposite-fiat-comisions/deposite-fiat-details/deposite-fiat-details.component';
import { WithdrawStakedDetailsComponent } from './pages/deposite-fiat-comisions/withdraw-staked-details/withdraw-staked-details.component';
import { AdminWalletComponent } from './pages/metamask/admin-wallet/admin-wallet.component';
import { TokenTransactionComponent } from './pages/metamask/token-transaction/token-transaction.component';
import { UserWalletTransactionComponent } from './pages/metamask/user-wallet-transaction/user-wallet-transaction.component';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { DateToDateSearchComponent } from './shared/components/date-to-date-search/date-to-date-search.component';
import { AddDurationRateComponent } from './pages/earn/components/add-duration-rate/add-duration-rate.component';
import { CoinDurationRateListComponent } from './pages/earn/components/coin-duration-rate-list/coin-duration-rate-list.component';
import { EarningRequestComponent } from './pages/earn/components/earning-request/earning-request.component';
import { HoldingsComponent } from './pages/earn/components/holdings/holdings.component';
import { ReferralEarningsComponent } from './pages/earn/components/referral-earnings/referral-earnings.component';
import { ReleasedEarningsComponent } from './pages/earn/components/released-earnings/released-earnings.component';
import { AddTDSMasterComponent } from './pages/tds/components/add-tdsmaster/add-tdsmaster.component';
import { EditTDSMasterComponent } from './pages/tds/components/edit-tdsmaster/edit-tdsmaster.component';
import { FiatWithdrawTdsReportComponent } from './pages/tds/components/fiat-withdraw-tds-report/fiat-withdraw-tds-report.component';
import { TDSMasterComponent } from './pages/tds/components/tdsmaster/tdsmaster.component';
import { TDSReportComponent } from './pages/tds/components/tdsreport/tdsreport.component';
import { TradeTDSComponent } from './pages/tds/components/tradeTDS/tradeTDS.component'
import { UtilityPaymentsTdsReportComponent } from './pages/tds/components/utility-payments-tds-report/utility-payments-tds-report.component';
import { PassbookListComponent } from './pages/user/components/passbook-list/passbook-list.component';
import { UplineRefferelComponent } from './pages/upline-refferel/upline-refferel/upline-refferel.component';
import { MaintananceNotificationComponent } from './pages/maintainance-notification/maintanance-notification/maintanance-notification.component';
import { BlogPageComponent } from './pages/blog-page/blog-page/blog-page.component';
import { AllUserAssetComponent } from './pages/user-asset/all-user-asset/all-user-asset.component';
import { ExchangeInvestmentComponent } from './pages/arbitrage/components/exchange-investment/exchange-investment.component';
import { TotalInvestmentComponent } from './pages/arbitrage/components/total-investment/total-investment.component';
import { ExchangeHistoryComponent } from './pages/arbitrage/components/exchange-history/exchange-history.component';
import { LearnPageComponent } from './pages/learn-page/learn-page/learn-page.component';
//import { HoldingsComponent } from './pages/earn/holdings/holdings.component';



const APP_CONTAINERS = [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
];

if (environment.production) {
  enableProdMode();
}

@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    ConfirmationDialogComponent,
    Page403Component,
    Page404Component,
    Page500Component,
    AnnouncementComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
 //   EarnCoinListComponent,
    AddDurationRateComponent,
    EarningRequestComponent,
    CoinDurationRateListComponent,
    ReferralEarningsComponent,
    ReleasedEarningsComponent,
    TDSMasterComponent,
    AddTDSMasterComponent,
    FiatWithdrawTdsReportComponent,
    UtilityPaymentsTdsReportComponent,
    EditTDSMasterComponent,
    HoldingsComponent,
    TDSReportComponent,
    TradeTDSComponent,
    DepositeFiatCommisionComponent,
    DepositeFiatDetailsComponent,
    AdminWalletComponent,
    UserWalletTransactionComponent,
    TokenTransactionComponent,
    WithdrawStakedDetailsComponent,
    UplineRefferelComponent,
    MaintananceNotificationComponent,
    BlogPageComponent,
    AllUserAssetComponent,
    ExchangeInvestmentComponent,
    TotalInvestmentComponent,
    ExchangeHistoryComponent,
    LearnPageComponent,
    // DateToDateSearchComponent,
  ],
  imports: [
    CoreModule,
    SharedCoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    AvatarModule,
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    SidebarModule,
    SharedModule,
    TabsModule,
    ListGroupModule,
    ProgressModule,
    BadgeModule,
    ListGroupModule,
    CardModule,
    NgScrollbarModule,
    FormsModule,
    MatFormFieldModule,
    RouterModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MultiSelectModule,
    CKEditorModule,
    StoreDevtoolsModule.instrument(),
    StoreModule.forRoot({}),
    StoreModule.forFeature('role', roleReducer.reducer),
    ExportAsModule,
  
  ],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
    // Default values: `idle` is 600 (10 minutes), `timeout` is 300 (5 minutes)
    // and `ping` is 120 (2 minutes).
    provideUserIdleConfig({ idle: 1800, timeout: 1, ping: 0 }),
    IconSetService,
    Title,
    ConfirmationDialogService,
    provideStore(),
    // extModules
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
